<template>
  <div
    ref="tipBlock"
    class="d-follow-tip"
    :class="{
      bottom: isPopupOutOfScreen && isPopupOutOfScreen.bottom,
      left: isPopupOutOfScreen && isPopupOutOfScreen.left,
      right: isPopupOutOfScreen && isPopupOutOfScreen.right,
    }"
    :style="position"
    @mouseleave="closeTip"
    @scroll="closeTip"
  >
    <span class="tip" />
    <span class="text">Follow {{ authorInfo.author_name }}?</span>
    <DFollowButton
      :user-id="authorInfo.author_id"
      :is-small-button="true"
      :is-black-button="true"
      @add-follow="addFollow"
    />
  </div>
</template>

<script>
import Vue from 'vue';

import ElementPosition from '@d-shared/utils/element-position';

import DFollowButton from '../d-follow-button/d-follow-button.vue';

export default {
  components: {
    DFollowButton,
  },
  props: {
    authorInfo: {
      type: Object,
      required: true,
    },
    button: {
      type: Node,
      required: true,
    },
  },
  data: () => ({
    isPopupOutOfScreen: null,
    buttonParams: {
      top: null,
      left: null,
      width: null,
      height: null,
    },
  }),
  computed: {
    position: function() {
      const visibleTipSize = 12;
      const blockInitHeight = 50;
      const twoEmSpace = 16;
      const tipBlockElRects = this.$refs.tipBlock && this.$refs.tipBlock.getBoundingClientRect();
      const tipBlockHeight = tipBlockElRects ? tipBlockElRects.height + visibleTipSize : blockInitHeight;
      const tipBlockWidth = tipBlockElRects ? tipBlockElRects.width : 0;

      return {
        top:
          this.isPopupOutOfScreen && this.isPopupOutOfScreen.bottom
            ? `${this.buttonParams.top + this.buttonParams.height + visibleTipSize}px`
            : `${this.buttonParams.top - tipBlockHeight}px`,
        left:
          this.isPopupOutOfScreen && this.isPopupOutOfScreen.left
            ? `${this.buttonParams.left }px`
            : this.isPopupOutOfScreen && this.isPopupOutOfScreen.right
              ? 'unset'
              : `${this.buttonParams.left + this.buttonParams.width / 2 - tipBlockWidth / 2}px`,
        right:
          this.isPopupOutOfScreen && this.isPopupOutOfScreen.right
            ? `${window.innerWidth - this.buttonParams.left - this.buttonParams.width - visibleTipSize - twoEmSpace}px`
            : 'unset',
      };
    },
  },
  beforeDestroy() {
    this.removeListeners();
    this.closeTip();
  },
  mounted() {
    this.init();
    this.addListeners();
  },
  methods: {
    async init() {
      Vue.duiUniqueInstanceManager.ensureUnique('followTip', this);
      await this.setPosition();
    },
    async setPosition() {
      const buttonRect = this.button.getBoundingClientRect();
      this.$set(this, 'buttonParams', {
        top: buttonRect.top + window.scrollY,
        left: buttonRect.x + window.scrollX,
        height: buttonRect.height,
        width: buttonRect.width,
      });

      await this.$nextTick();
      this.isPopupVisible();
    },
    isPopupVisible() {
      const menuElement = document.querySelector('.d-top-menu-container');
      const menuHeight = menuElement ? menuElement.getBoundingClientRect().height : 0;

      this.$set(this, 'isPopupOutOfScreen', {
        bottom: ElementPosition.isElementOutOfTop(this.$refs.tipBlock, menuHeight),
        left: ElementPosition.isElementOutOfLeft(this.$refs.tipBlock),
        right: ElementPosition.isElementOutOfRight(this.$refs.tipBlock),
      });
    },
    closeTip() {
      this.$emit('close-tip');
    },
    addFollow() {
      Vue.duiNotificationManager.success('Followed successfully.');
      this.closeTip();
    },
    addListeners() {
      window.addEventListener('scroll', this.closeTip);
      window.addEventListener('resize', this.setPosition);
    },
    removeListeners() {
      window.removeEventListener('scroll', this.closeTip);
      window.removeEventListener('resize', this.setPosition);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-follow-tip {
  align-items: center;
  background-color: getColor($black);
  border-radius: $border-radius-xxl;
  box-shadow: $box-shadow-panel;
  color: getColor($white);
  display: flex;
  font-size: $font-size-base;
  padding: $_0-5em $_0-5em $_0-5em $_2em;
  position: absolute;
  z-index: $z-index-follow-tip;

  &::before {
    content: '';
    position: absolute;
    top: -$_0-5em;
    left: -$_0-5em;
    right: -$_0-5em;
    bottom: -$_0-5em;
  }

  .text {
    white-space: nowrap;
    margin-right: $_1em;
  }

  .tip {
    @include makeTip();

    left: 50%;
    transform: translateX(-50%);
    top: calc(100% - #{$tip-size});
  }

  &.bottom {
    .tip {
      top: -$tip-size;
      transform: translateX(-50%) rotate(180deg);
    }
  }

  &.left {
    transform: none;

    .tip {
      left: $_2em;
      transform: none;
    }
  }

  &.right {
    right: $_1em;
    transform: none;

    .tip {
      left: unset;
      right: $_2em;
      transform: none;
    }
  }
}
</style>
